// @flow

// - Stylesheet
import './inscription-step.less';

// - Vendors
import { View } from '@insolus/backbone';
import Config   from '@insolus/config';

// - Components
import StepSubject   from '../inscription-step-subject';
import StepCourse    from '../inscription-step-course';
import StepAuth      from '../inscription-step-auth';
import StepStudent   from '../inscription-step-student';

const StepViews = {
    'subject' : StepSubject,
    'course'  : StepCourse,
    'auth'    : StepAuth,
    'student' : StepStudent
};

class InscriptionStep extends View {
    get isPrerendered(): boolean { return true; }

    StepView: StepSubject | StepCourse | StepAuth | StepStudent;
    currentStep: string;

    initialize() {
        this.currentStep = Config.get('currentStep');

        this.render();
    }

    // ——————————————————————————————————————————————————————
    // —
    // —     Rendering
    // —
    // ——————————————————————————————————————————————————————

    bindElements() {
        this.$filters  = this.$el.element('filters');
        this.$content  = this.$el.element('content');
        this.$errorMsg = this.$el.element('error-message');
    }

    onRender() {
        if (!this.StepView && StepViews[this.currentStep]) {
            if (this.currentStep === 'course') {
                const subjectId = Config.get('subjectId');
                this.StepView = new StepViews[this.currentStep]({
                    el: this.$content,
                    subjectId
                });
            } else {
                this.StepView = new StepViews[this.currentStep](this.$content);
            }
        }
    }
}

export default InscriptionStep;



// WEBPACK FOOTER //
// ./src/views/themes/front/components/inscription-step/inscription-step.js